import React from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = () => {
  const series = [
    {
      name: "STOCK ABC",
      data: [8987, 7345, 54567, 3245, 54767, 32323],
      gap: 1000,
    },
  ];

  const options = {
    chart: {
      type: "area",
      height: 350,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      fontFamily: "Pio Medium",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Profit Summary",
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#000000",
      },
    },
    labels: ["Jan", "Feb", "March", "April", "May", "June"],
    xaxis: {
      type: "",
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#6b7280",
      },
    },
    yaxis: {
      opposite: false,
      style: {
        color: "#6b7280",
        fontSize: "12px",
      },
    },
    legend: {
      horizontalAlign: "left",
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <div>
      <div id="chart" style={{ fontFamily: "text-medium" }}>
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default AreaChart;
